module.exports = __webpack_public_path__ + "img/Not-regis-qr-code.acd75431.png";